<template>
  <div class="text-object">
    <div v-if="!editing" @click="startEdit">
      <div v-if="parsedText.length === 0" class="empty">Start typing...</div>
      <p v-html="parsedText" class="parsed-text" :style="style"></p>
    </div>
    <textarea 
      v-else 
      v-model="text" 
      ref="textarea" 
      cols="30" 
      rows="10" 
      :style="style" 
      @input="update"
      @blur="editing = false"
      autofocus
      :readonly="!canEdit"></textarea>
  </div>
</template>

<script>

const showdown  = require('showdown');

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      converter: new showdown.Converter(),
      text: '',
      editing: false
    }
  },
  methods: {
    startEdit() {
      this.editing = true
      setTimeout(() => {
        this.$refs.textarea.focus();
      }, 100);
    },
    applyUpdate(changes) {
      if (changes.text) this.text = changes.text;
    },
    update() {
      this.$emit('input', {
        text: this.text
      })
    },
    onClickOutside() {
      
    }
  },
  computed: {
    style: function() {
      return `
        resize: none;
        color: ${this.data.textColour}
      `;
    },
    parsedText: function() {
      return this.converter.makeHtml(this.text)
          .replace('<code>', `<code style="${this.codeStyle}">`)
          .replace('<p', '<p style="font-size:12px"')
          .replace('<li', '<li style="font-size:12px"')
          .replace('<h1', '<h1 style="font-size:20px"')
          .replace('<h2', '<h2 style="font-size:16px"')
          .replace('<h3', '<h3 style="font-size:14px"')
    },
    codeStyle: function() {
      return `
        background-color: #575656;
        padding: 0 10px;
        color: #f7a737;
        border-radius: 3px;
        font-size:12px;
      `;
    }
  },
  mounted() {
    if (!this.text) this.text = this.data.text || '';
  }
}
</script>

<style scoped>

textarea {
  background-color: transparent;
  border: none;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
}

p {
  background-color: transparent;
  border: none;
  width: 100%;

  user-select: all;
  cursor: text;

  font-size: 12px;
}

.text-object {
  overflow-y: scroll;
}

.empty {
  color: #9a9a9a;
  font-size: 12px;
}

.parsed-text {
  word-wrap: break-word;
}

::-webkit-scrollbar, 
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

</style>



// WEBPACK FOOTER //
// src/components/TextObject.vue